import EmberRouter from '@ember/routing/router';
import { EMBER_ROUTE_NAMES, EMBER_ROUTE_PARTIALS } from 'sh-www/constants/routes';
import { isInDevMode } from 'sh-www/utils/misc';

import config from 'sh-www/config/environment';

const Router = EmberRouter.extend({
  location: config.locationType,
  rootURL: config.rootURL,
});

Router.map(function () {
  if (isInDevMode()) {
    this.route(EMBER_ROUTE_NAMES.ALL_ROUTES);
  }

  // Start/stop heartbeat
  this.route('bootstrap-app', { path: '/' }, function () {
    this.route('deactivated', { resetNamespace: true });
    this.route('delinquent', { resetNamespace: true });

    // Requires completing the funnel
    this.route('requires-funnel', { path: '/', resetNamespace: true }, function () {
      this.route('index', { path: '/', resetNamespace: true });
      this.route('dashboard', { resetNamespace: true });
      this.route('refer', { resetNamespace: true });
      this.route('start', { resetNamespace: true });

      this.route(EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS, { resetNamespace: true }, function () {
        this.route(EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS__PROJECTS);
        this.route(EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS__FREELANCERS);
        this.route(EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS__INVOICES);
        this.route(EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS__CREDITS);
        this.route(EMBER_ROUTE_PARTIALS.COMPANY_ANALYTICS__TOTALS);
      });

      this.route(EMBER_ROUTE_PARTIALS.COMPANY_PROFILE, {
        path: '/company/:companyId',
        resetNamespace: true
      }, function () {
        this.route(EMBER_ROUTE_PARTIALS.COMPANY_FREELANCER, { path: '/user/:profileId' });
        this.route(EMBER_ROUTE_PARTIALS.COMPANY_VIEW, { path: '/view' });
      });

      this.route(EMBER_ROUTE_PARTIALS.COMPANY_PROFILE, { path: '/company/:companyId', resetNamespace: true });

      this.route(EMBER_ROUTE_PARTIALS.MESSAGE_CENTER, { path: '/messages', resetNamespace: true }, function () {
        this.route(EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__INBOX, function () {
          this.route(EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__INBOX__THREAD, { path: '/:threadId' });
        });
        this.route(EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__ARCHIVE, function () {
          this.route(EMBER_ROUTE_PARTIALS.MESSAGE_CENTER__ARCHIVE__THREAD, { path: '/:threadId' });
        });
      });

      this.route(EMBER_ROUTE_PARTIALS.SETTINGS, { resetNamespace: true }, function () {
        this.route(EMBER_ROUTE_PARTIALS.SETTINGS__PROFILE);
        this.route(EMBER_ROUTE_PARTIALS.SETTINGS__BACKGROUND);
        this.route(EMBER_ROUTE_PARTIALS.SETTINGS__OPTIONS);
        this.route('company', { path: '/company/*any' });
        this.route('company');

        this.route(EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT, function () {
          this.route(EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__ADD_METHOD, function () {
            this.route(EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__ADD_METHOD__PERSONAL_INFO);
            this.route(EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__ADD_METHOD__TRANSFER_METHOD);
            this.route(EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__ADD_METHOD__SELECT_METHOD);
            this.route(EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__ADD_METHOD__PAYONEER_SETUP);
          });

          this.route(EMBER_ROUTE_PARTIALS.SETTINGS__PAYOUT__PAYEE_VERIFICATION);
        });

        this.route(EMBER_ROUTE_PARTIALS.SETTINGS__NOTIFICATION_PREFERENCES);
        this.route(EMBER_ROUTE_PARTIALS.SETTINGS__CREDENTIALS);
        this.route(EMBER_ROUTE_PARTIALS.SETTINGS__RESET_EMAIL);
        this.route('taxes');
      });

      this.route(EMBER_ROUTE_PARTIALS.PEOPLE_CENTER, { path: '/people', resetNamespace: true }, function () {
        this.route(EMBER_ROUTE_PARTIALS.PEOPLE_CENTER__MY_NETWORK);
        this.route(EMBER_ROUTE_PARTIALS.PEOPLE_CENTER__SEARCH);
      });

      this.route(EMBER_ROUTE_PARTIALS.POSTING__CREATE, { path: '/posting/create', resetNamespace: true }, function () {
        this.route(EMBER_ROUTE_PARTIALS.INDEX, { path: '' });
        this.route(EMBER_ROUTE_PARTIALS.POSTING__CREATE__PITCHES, { path: '/pitch' });
        this.route(EMBER_ROUTE_PARTIALS.POSTING__CREATE__FIND_FREELANCERS, { path: '/find-freelancer' });
        this.route(EMBER_ROUTE_PARTIALS.POSTING__CREATE__SELECT, { path: '/select' });
      });

      this.route(EMBER_ROUTE_PARTIALS.PROJECT__CREATE, { path: '/project/create', resetNamespace: true }, function () {
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__CREATE__FIND_FREELANCER, { path: '/find-freelancer' });
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__CREATE__DIRECT, { path: '/:freelancerId' });
      });

      this.route(EMBER_ROUTE_PARTIALS.PROJECT__DETAILS, {
        path: '/project/:projectIdOrSlug',
        resetNamespace: true
      }, function () {
        this.route(EMBER_ROUTE_PARTIALS.INDEX, { path: '' });
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__DETAILS__ACTIVITY, { path: '/activity' });
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__DETAILS__DETAILS, { path: '/details' });
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__DETAILS__DELIVERABLES, { path: '/deliverables' });
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__DETAILS__FILES, { path: '/files' });
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__DETAILS__PAYMENT, { path: '/payment' });
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__DETAILS__PITCH, { path: '/pitch' });
      });

      this.route(EMBER_ROUTE_PARTIALS.PROJECT__ADVANCE, {
        path: '/project-advance/:projectIdOrSlug',
        resetNamespace: true
      }, function () {
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__ADVANCE__APPROVE, { path: '/approve' });
      });

      this.route(EMBER_ROUTE_PARTIALS.PROJECT__CANCELLATION, {
        path: '/cancel-project/:projectIdOrSlug',
        resetNamespace: true
      }, function () {
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__CANCELLATION__CANCEL_SUBMITTED, { path: '/cancel-submitted' });
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__CANCELLATION__CONFIRM, { path: '/confirm' });
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__CANCELLATION__DETAILS, { path: '/details' });
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__CANCELLATION__PAYMENT, { path: '/payment' });
      });

      this.route(EMBER_ROUTE_PARTIALS.PROJECT__COMPLETE, {
        path: '/complete-project/:projectIdOrSlug',
        resetNamespace: true
      }, function () {
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__COMPLETE__PRIVATE_FEEDBACK, { path: '/private-feedback' });
        this.route(EMBER_ROUTE_PARTIALS.PROJECT__COMPLETE__PUBLIC_FEEDBACK, { path: '/public-feedback' });
      });

      this.route(EMBER_ROUTE_PARTIALS.POSTING, { path: '/posting/:assignId', resetNamespace: true }, function () {
        this.route(EMBER_ROUTE_PARTIALS.INDEX, { path: '' });
        this.route(EMBER_ROUTE_PARTIALS.POSTING__APP, { path: '/app/:applicationId' });
        this.route(EMBER_ROUTE_PARTIALS.POSTING__CLOSE, { path: '/close' });
        this.route(EMBER_ROUTE_PARTIALS.POSTING__EDIT, { path: '/edit' });
        this.route(EMBER_ROUTE_PARTIALS.POSTING__DECLINED, { path: '/declined' });
        this.route(EMBER_ROUTE_PARTIALS.POSTING__HIRED, { path: '/hired' });
        this.route(EMBER_ROUTE_PARTIALS.POSTING__PENDING, { path: '/pending' });
        this.route(EMBER_ROUTE_PARTIALS.POSTING__APPLY);
      });

      this.route(EMBER_ROUTE_PARTIALS.POSTINGS, { path: '/postings', resetNamespace: true }, function () {
        this.route(EMBER_ROUTE_PARTIALS.INDEX, { path: '' });
        this.route(EMBER_ROUTE_PARTIALS.POSTINGS__LIVE);
        this.route(EMBER_ROUTE_PARTIALS.POSTINGS__DRAFT);
        this.route(EMBER_ROUTE_PARTIALS.POSTINGS__CLOSED);
        this.route(EMBER_ROUTE_PARTIALS.POSTINGS__IN_REVIEW);

        this.route(EMBER_ROUTE_PARTIALS.POSTINGS__FIND_WORK, function () {
          this.route(EMBER_ROUTE_PARTIALS.POSTINGS__FIND_WORK__RECOMMENDED);
          this.route(EMBER_ROUTE_PARTIALS.POSTINGS__FIND_WORK__OTHER);
          this.route(EMBER_ROUTE_PARTIALS.POSTINGS__FIND_WORK__SAVED);
        });
        this.route(EMBER_ROUTE_PARTIALS.POSTINGS__OTHER);
        this.route(EMBER_ROUTE_PARTIALS.POSTINGS__RECOMMENDED);
        this.route(EMBER_ROUTE_PARTIALS.POSTINGS__SEARCH);
        this.route(EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS, function () {
          this.route(EMBER_ROUTE_PARTIALS.INDEX, { path: '' });
          this.route(EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS__HIRED);
          this.route(EMBER_ROUTE_PARTIALS.POSTINGS__APPLICATIONS__SUBMITTED);
        });
      });

      this.route(EMBER_ROUTE_PARTIALS.PROJECTS, { path: '/projects', resetNamespace: true }, function () {
        this.route(EMBER_ROUTE_PARTIALS.INDEX, { path: '' });
        this.route(EMBER_ROUTE_PARTIALS.PROJECTS__IN_PROGRESS);
        this.route(EMBER_ROUTE_PARTIALS.PROJECTS__COMPLETE);
        this.route(EMBER_ROUTE_PARTIALS.PROJECTS__CANCELLED);

        this.route(EMBER_ROUTE_PARTIALS.PROJECTS__ACTIVE);
        this.route(EMBER_ROUTE_PARTIALS.PROJECTS__PENDING);
        this.route(EMBER_ROUTE_PARTIALS.PROJECTS__ARCHIVED);
        this.route(EMBER_ROUTE_PARTIALS.PROJECTS__SEARCH);
      });

      this.route(EMBER_ROUTE_PARTIALS.UPGRADE, { resetNamespace: true });
    });

    // Admin routes

    this.route(EMBER_ROUTE_PARTIALS.ADMIN, { resetNamespace: true }, function () {
      this.route(EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING, function () {
        this.route(EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING__ACCOUNTS_RECEIVABLE);
        this.route(EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING__ACCOUNTS_AGING);
        this.route(EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING__PAYIN, function () {
          this.route(EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING__PAYIN__SH_INVOICE, { path: '/:shInvoiceId' });
        });
        this.route(EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING__PAYOUT, function () {
          this.route(EMBER_ROUTE_PARTIALS.ADMIN__ACCOUNTING__PAYOUT__SH_PAYMENT, { path: '/:shPaymentId' });
        });
      });
      this.route(EMBER_ROUTE_PARTIALS.ADMIN__BLASTER, { path: '/blaster/:postingId' });
      this.route(EMBER_ROUTE_PARTIALS.ADMIN__CLASSIFICATION, { path: '/classification' });
      this.route(EMBER_ROUTE_PARTIALS.ADMIN__COMPANIES, { path: '/companies' });
      this.route(EMBER_ROUTE_PARTIALS.ADMIN__VETTING_QUEUE, { path: '/vetting-queue' });
      this.route(EMBER_ROUTE_PARTIALS.ADMIN__COMPANY, { path: '/company' }, function () {
        this.route(EMBER_ROUTE_PARTIALS.ADMIN__COMPANY__CREATE, { path: '/create' });
      });
      this.route(EMBER_ROUTE_PARTIALS.ADMIN__CONTENT, { path: '/content' });
      this.route(EMBER_ROUTE_PARTIALS.ADMIN__LEGAL, { path: '/legal' });
      this.route(EMBER_ROUTE_PARTIALS.ADMIN__MASQUERADE, { path: '/masquerade/:id' });
      this.route(EMBER_ROUTE_PARTIALS.ADMIN__REPORTS, { path: '/reports' });
      this.route(EMBER_ROUTE_PARTIALS.SITE_CONFIG);

      this.route(EMBER_ROUTE_PARTIALS.ADMIN__USER, { path: '/user/:user_slug' }, function () {
        this.route(EMBER_ROUTE_PARTIALS.ADMIN__USER__BILLING, { path: '/billing' });
        this.route(EMBER_ROUTE_PARTIALS.ADMIN__USER__RATE, { path: '/rate' });
      });

      this.route(EMBER_ROUTE_PARTIALS.ADMIN__USERS);
      this.route(EMBER_ROUTE_PARTIALS.ADMIN__POSTINGS);
      this.route(EMBER_ROUTE_PARTIALS.ADMIN__PROJECTS);

      this.route('productions', function () {
        this.route('create');
        this.route('view', { path: '/:slug' }, function () {
          this.route('edit');
        });
      });
    });

    // Catch all for any other routes not matched.
    this.route(EMBER_ROUTE_PARTIALS.PROFILE, { path : '/*profileId', resetNamespace: true });
  });

  // Signup

  this.route(EMBER_ROUTE_PARTIALS.JOIN_COMPANY);

  this.route(EMBER_ROUTE_PARTIALS.BRAND, function () {
    this.route(EMBER_ROUTE_PARTIALS.BRAND__SIGNUP, function () {
      this.route(EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP, function () {
        this.route(EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP__COMPANY_INFO);
        this.route(EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP__ABOUT_YOU);
        this.route(EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP__PAYMENT_METHOD);
        this.route(EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP__VERIFY_EMAIL);
        this.route(EMBER_ROUTE_PARTIALS.BRAND__SIGNUP__STEP__PENDING_APPROVAL);
      });
    });
  });

  this.route(EMBER_ROUTE_PARTIALS.SIGNUP, function () {
    this.route(EMBER_ROUTE_PARTIALS.SIGNUP__STEP, function() {
      this.route(EMBER_ROUTE_PARTIALS.SIGNUP__STEP__VERIFY_EMAIL);
      this.route(EMBER_ROUTE_PARTIALS.SIGNUP__STEP__PROFILE);
      this.route(EMBER_ROUTE_PARTIALS.SIGNUP__STEP__BACKGROUND);
      this.route(EMBER_ROUTE_PARTIALS.SIGNUP__STEP__WORK);
      this.route(EMBER_ROUTE_PARTIALS.SIGNUP__STEP__DONE);
    });
  });

  this.route('access-denied');

  // Unauthenticated Routes

  this.route('landing');
  this.route('logout');
  this.route('maintenance');
  this.route('plans');
  this.route('wizard', { path: '/wizard/*' });
  this.route('wizard');

  this.route(EMBER_ROUTE_NAMES.OUT);
  this.route(EMBER_ROUTE_PARTIALS.PAGE_NOT_FOUND);
  this.route(EMBER_ROUTE_NAMES.PRIVACY_POLICY);
  this.route(EMBER_ROUTE_NAMES.PRIVACY);
  this.route(EMBER_ROUTE_NAMES.TERMS_OF_SERVICE);
  this.route(EMBER_ROUTE_NAMES.CONTRACTOR_AGREEMENT);
  this.route(EMBER_ROUTE_NAMES.MASTER_PUBLISHER_AGREEMENT);
  this.route('complaint-policy');
  this.route('copyright-policy');

  this.route(EMBER_ROUTE_NAMES.SIGNIN, function () {
    this.route(EMBER_ROUTE_PARTIALS.SIGNIN__SAML);
  });
  this.route(EMBER_ROUTE_NAMES.SIGNOUT);
  this.route(EMBER_ROUTE_NAMES.VERIFY_EMAIL);
  this.route(EMBER_ROUTE_NAMES.RESET_PASSWORD);
  this.route(EMBER_ROUTE_PARTIALS.END_MASQUERADE, { path: '/end-masquerade' });

  this.route(EMBER_ROUTE_PARTIALS.REFERRAL, function () {
    this.route(EMBER_ROUTE_PARTIALS.REFERRAL__RECEIVE);
  });

  this.route(EMBER_ROUTE_PARTIALS.IFRAME, function() {
    this.route(EMBER_ROUTE_PARTIALS.IFRAME__DIRECT_HIRE);
  });
});

export default Router;
